import { Pipe, PipeTransform } from '@angular/core';
import { CustomerRemarkPluginService } from './customerremark-plugin.service';

@Pipe({
    name: 'customerremarktype',
    standalone: false
})
export class CustomerRemarkTypePipe implements PipeTransform {
  public types: any;

  constructor(private service: CustomerRemarkPluginService) {
    this.types = this.service.getTypes();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.types);
  }
}
